import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PublicLayout } from './layouts/PublicLayout';
import { AdminLayout } from './layouts/AdminLayout';
import { TenantLayout } from './layouts/TenantLayout';
import { PartnerLayout } from './layouts/PartnerLayout';
import { LoginPage } from './pages/public/LoginPage';
import { LandingPage } from './pages/public/LandingPage';
import { DashboardPage } from './pages/admin/DashboardPage';
import { ProductsPage } from './pages/admin/ProductsPage';
import { UsersPage } from './pages/admin/UsersPage';
import { WebhookSetupGuidePage } from './pages/admin/WebhookSetupGuidePage';
import { WebhookMappingsPage } from './pages/admin/WebhookMappingsPage';
import { TenantsPage } from './pages/admin/TenantsPage';
import { TenantDetailPage } from './pages/admin/TenantDetailPage';
import { PartnerApplicationsPage } from './pages/admin/PartnerApplicationsPage';
import { OEMProductsPage } from './pages/admin/OEMProductsPage';
import { UsageGuidePage } from './pages/admin/UsageGuidePage';
import { RevenuePage } from './pages/admin/RevenuePage';
import SettingsPage from './pages/admin/SettingsPage';
import TenantDashboardPage from './pages/tenant/TenantDashboardPage';
import PartnerDashboardPage from './pages/partner/PartnerDashboardPage';
import PartnerProductsPage from './pages/partner/PartnerProductsPage';
import PartnerPaymentLinksPage from './pages/partner/PartnerPaymentLinksPage';
import PartnerRevenuePage from './pages/partner/PartnerRevenuePage';
import PartnerCustomersPage from './pages/partner/PartnerCustomersPage';
import PartnerBrandingPage from './pages/partner/PartnerBrandingPage';
import PartnerStripePage from './pages/partner/PartnerStripePage';
import PartnerApplyPage from './pages/partner/PartnerApplyPage';
import PartnerLandingPage from './pages/partner/PartnerLandingPage';
import CheckoutPage from './pages/checkout/CheckoutPage';
import CheckoutSuccessPage from './pages/checkout/CheckoutSuccessPage';
import MyPage from './pages/user/MyPage';
import { theme } from './theme/theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* 公開ルート */}
            <Route path="/" element={<LandingPage />} />
            <Route element={<PublicLayout />}>
              <Route path="/login" element={<LoginPage />} />
            </Route>

            {/* チェックアウト（公開） */}
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/checkout/*" element={<CheckoutPage />} />

            {/* パートナー募集LP・申請（公開） */}
            <Route path="/partner" element={<PartnerLandingPage />} />
            <Route path="/partner/apply" element={<PartnerApplyPage />} />

            {/* 保護ルート（管理者専用） */}
            <Route
              element={
                <ProtectedRoute requireAdmin>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/admin/dashboard" element={<DashboardPage />} />
              <Route path="/admin/products" element={<ProductsPage />} />
              <Route path="/admin/users" element={<UsersPage />} />
              <Route path="/admin/tenants" element={<TenantsPage />} />
              <Route path="/admin/tenants/:id" element={<TenantDetailPage />} />
              <Route path="/admin/partner-applications" element={<PartnerApplicationsPage />} />
              <Route path="/admin/oem-products" element={<OEMProductsPage />} />
              <Route path="/admin/revenue" element={<RevenuePage />} />
              <Route path="/admin/settings" element={<SettingsPage />} />
              <Route path="/admin/webhook-setup" element={<WebhookSetupGuidePage />} />
              <Route path="/admin/webhook-mappings" element={<WebhookMappingsPage />} />
              <Route path="/admin/usage-guide" element={<UsageGuidePage />} />
            </Route>

            {/* テナント管理者用ルート */}
            <Route
              element={
                <ProtectedRoute requireTenant>
                  <TenantLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/tenant/dashboard" element={<TenantDashboardPage />} />
            </Route>

            {/* OEMパートナー用ルート */}
            <Route
              element={
                <ProtectedRoute requirePartner>
                  <PartnerLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/partner/dashboard" element={<PartnerDashboardPage />} />
              <Route path="/partner/products" element={<PartnerProductsPage />} />
              <Route path="/partner/payment-links" element={<PartnerPaymentLinksPage />} />
              <Route path="/partner/revenue" element={<PartnerRevenuePage />} />
              <Route path="/partner/customers" element={<PartnerCustomersPage />} />
              <Route path="/partner/branding" element={<PartnerBrandingPage />} />
              <Route path="/partner/settings/stripe" element={<PartnerStripePage />} />
            </Route>

            {/* 一般ユーザー用ルート */}
            <Route
              path="/mypage"
              element={
                <ProtectedRoute>
                  <MyPage />
                </ProtectedRoute>
              }
            />

            {/* 不明なパスはLPへリダイレクト */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
